import React, { useState } from "react";
import { Badge, Button, Card, Descriptions, Drawer } from "antd";
import { useDispatch } from "react-redux";
import { updateMachine } from "../../../redux/Machine/actions";
import EditMachineButton from "./EditMachineButton";
import DeleteMachineButton from "./DeleteMachineButton";
import MachinePC from "./MachinePC";
import ShowMachine from "./ShowMachine";
import ShowMachineUserDetails from "./ShowMachineUserDetails";

const MachineCard = ({ item ,users}) => {
  const dispatch = useDispatch();
  const [isDrawerVisible, setIsDrawerVisible] = useState(false);

  const toggleMachineStatus = () => {
    dispatch(updateMachine(item._id, { isActive: !item.isActive }));
  };

  const showDrawer = () => {
    setIsDrawerVisible(true);
  };

  const closeDrawer = () => {
    setIsDrawerVisible(false);
  };

  return (
    <Card
      title={
        item.isActive ? 
        <Badge status="success" text="Activé" /> : 
        <Badge status="error" text="Désactivé" />
      }
      style={{
        marginBottom: 15,
        minWidth: 320,
        boxShadow: "1px 1px 1px #9E9E9E",
        borderRadius: "5px",
      }}
      bordered={true}
      extra={
        <Button onClick={toggleMachineStatus}>
          {item.isActive ? "Désactiver" : "Activer"}
        </Button>
      }
      actions={[
        <ShowMachine item={item} key="view" />,
        <EditMachineButton item={item} users={users} />,
        <MachinePC item={item} />,
        <DeleteMachineButton item={item} />,
      ]}
    >

      <Descriptions
        style={{ width: "100%" }}
        bordered
        column={1}
        layout="horizontal"
      >
        <Descriptions.Item label="User">
          {item.user ? (
                    <ShowMachineUserDetails userId={item.user} />

          ) : (
            'N/A'
          )}
        </Descriptions.Item>
        <Descriptions.Item label="Machine">{item.machinename}</Descriptions.Item>
        <Descriptions.Item label="ID">{item.machineid}</Descriptions.Item>
      </Descriptions>

      <Drawer
        title="User Details"
        placement="right"
        onClose={closeDrawer}
        visible={isDrawerVisible}
        width={500}
      >
        <ShowMachineUserDetails userId={item.user} />
      </Drawer>
    </Card>
  );
};

export default MachineCard;
